import React from 'react'
import { useRouter } from 'next/router'
import { AnnouncementProvider } from '@/src/context/AnnouncementContext'
import { useAuth } from '@/src/hooks/useAuth'
import AnnouncementBanner from './AnnouncementBanner'
import ErrorBoundary from './ErrorBoundary'

interface GlobalAnnouncementBannerProps {
  children: React.ReactNode
}

const GlobalAnnouncementBanner: React.FC<GlobalAnnouncementBannerProps> = ({ children }) => {
  const router = useRouter()
  const { user } = useAuth()

  // Get current page path for targeting
  const currentPage = router.pathname

  return (
    <>
      <ErrorBoundary
        fallback={
          <div style={{ padding: '16px', textAlign: 'center', color: '#666' }}>
            Announcements temporarily unavailable
          </div>
        }
      >
        <AnnouncementProvider userId={user?.id} currentPage={currentPage}>
          <AnnouncementBanner showMultiple={true} />
        </AnnouncementProvider>
      </ErrorBoundary>
      {children}
    </>
  )
}

export default GlobalAnnouncementBanner
